var React = require('react');

function CtaArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.625 10H20.375","stroke":"#0E0916","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M11.625 18.75L20.375 10L11.625 1.25","stroke":"#0E0916","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CtaArrowInline.defaultProps = {"width":"22","height":"20","viewBox":"0 0 22 20","fill":"none"};

module.exports = CtaArrowInline;

CtaArrowInline.default = CtaArrowInline;
